import { Component, OnInit, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'hc-button-dropdown',
  templateUrl: './button-dropdown.component.html',
  styleUrls: ['./button-dropdown.component.scss']
})
export class ButtonDropdownComponent implements OnInit {
  @Input() showOptionsFlag: boolean = false;
  @Input() labelButton: string;
  @Input() options: any[];
  @Output() optionClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  public showOptions() {
    this.showOptionsFlag = true;
    this.optionClick.emit({ value: 'show-options' });
  }

  public optionClicked(value: string) {
    this.optionClick.emit({ value: value });
  }


}
